import React, {useCallback, useEffect, useState} from 'react';

import {Box, Button, Grid, Tab, Tabs, Select, MenuItem, FormControl} from '@material-ui/core';
import ExerciseBox from '@user-pages/exercise/ExerciseBox'
import Typography from "@material-ui/core/Typography";
import FirstMeasureMessage from "../../../components/FirstMeasureMessage";
import NeedTicketDialog from "../../../components/NeedTicketDialog";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {makeStyles} from "@material-ui/core/styles";
import MeasureTestHistoryDialog from "./MeasureTestHistoryDialog";
import clsx from "clsx";
import StarIcon from "@material-ui/icons/Star";
import HeatMap from "react-heatmap-grid";
import ColorHelper from '@helper/ColorHelper';

import SurveyService from '@user-service/SurveyService'
import MeasureService from '@user-service/MeasureService'
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import SubMenuTabLabel from "../../../components/SubMenuTabLabel";

const MeasureTestDefault = (props) => {
    const [open, setOpen] = useState(false)
    
    const { state, measureType } = props
    const [ showHistory, setHistory ] = useState(false)
    const { exercise, prescription, measureTypesCount } = state
    const classes = useStyles()
    const [ currentSelect, setCurrentSelect ] = useState(0)
  
    const handleTab = (select) => {
      setCurrentSelect(select)
    }

    
  const [survey, setSurvey] = useState(null)
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
  const [viewType, setViewType] = useState('year') // 'year', 'week', 'day'
  const [currentQuarter, setCurrentQuarter] = useState(Math.ceil((new Date().getMonth() + 1) / 3)) // 1-4
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1) // 1-12
  const [selectedMode, setSelectedMode] = useState(['develop','train'].includes(measureType) ? 'train' : 'challenge') // 'train' or 'challenge'

  const fetchHSurveyHistory = useCallback(async () => {
    let res;
    const exerciseType = ['develop','train'].includes(measureType) ? 'train' : 'test';
    const mode = ['develop','train'].includes(measureType) ? selectedMode : null;
    
    if (viewType === 'year') {
      res = await MeasureService.getMeasureTestYear(currentYear, exerciseType, mode);
    } else if (viewType === 'week') {
      // 분기별 주간 데이터 가져오기
      res = await MeasureService.getMeasureTestQuarter(currentYear, currentQuarter, exerciseType, mode);
    } else if (viewType === 'day') {
      // 월별 일간 데이터 가져오기
      res = await MeasureService.getMeasureTestMonth(currentYear, currentMonth, exerciseType, mode);
    }
    
    setSurvey(res)
  }, [currentYear, currentQuarter, currentMonth, viewType, selectedMode, measureType, props.surveyType])

  useEffect(()=>{
    fetchHSurveyHistory().then()
  },[fetchHSurveyHistory])

  const handlePrevious = () => {
    if (viewType === 'year') {
      setCurrentYear(currentYear - 1);
    } else if (viewType === 'week') {
      if (currentQuarter > 1) {
        setCurrentQuarter(currentQuarter - 1);
      } else {
        setCurrentQuarter(4);
        setCurrentYear(currentYear - 1);
      }
    } else if (viewType === 'day') {
      if (currentMonth > 1) {
        setCurrentMonth(currentMonth - 1);
      } else {
        setCurrentMonth(12);
        setCurrentYear(currentYear - 1);
      }
    }
  };

  const handleNext = () => {
    if (viewType === 'year') {
      setCurrentYear(currentYear + 1);
    } else if (viewType === 'week') {
      if (currentQuarter < 4) {
        setCurrentQuarter(currentQuarter + 1);
      } else {
        setCurrentQuarter(1);
        setCurrentYear(currentYear + 1);
      }
    } else if (viewType === 'day') {
      if (currentMonth < 12) {
        setCurrentMonth(currentMonth + 1);
      } else {
        setCurrentMonth(1);
        setCurrentYear(currentYear + 1);
      }
    }
  };

  const getQuarterMonthRange = (quarter) => {
    const ranges = {
      1: '1-3월',
      2: '4-6월',
      3: '7-9월',
      4: '10-12월'
    };
    return ranges[quarter];
  };

  const getDateRangeText = () => {
    if (viewType === 'year') {
      return <span>{currentYear}년</span>;
    } else if (viewType === 'week') {
      return (
        <span>
          <span style={{ fontSize: '18px', opacity: 0.7 }}>{currentYear}년</span>
          <span style={{ fontSize: '32px', fontWeight: 'bold', marginLeft: '8px' }}>{getQuarterMonthRange(currentQuarter)}</span>
        </span>
      );
    } else {
      return (
        <span>
          <span style={{ fontSize: '18px', opacity: 0.7 }}>{currentYear}년</span>
          <span style={{ fontSize: '32px', fontWeight: 'bold', marginLeft: '8px' }}>{currentMonth}월</span>
        </span>
      );
    }
  };

  const getPreviousText = () => {
    if (viewType === 'year') {
      return `${currentYear - 1}년`;
    } else if (viewType === 'week') {
      const prevQuarter = currentQuarter > 1 ? currentQuarter - 1 : 4;
      const prevYear = currentQuarter > 1 ? currentYear : currentYear - 1;
      return (
        <span>
          {prevYear !== currentYear && <span style={{ fontSize: '14px', opacity: 0.7 }}>{prevYear}년 </span>}
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{getQuarterMonthRange(prevQuarter)}</span>
        </span>
      );
    } else {
      const prevMonth = currentMonth > 1 ? currentMonth - 1 : 12;
      const prevYear = currentMonth > 1 ? currentYear : currentYear - 1;
      return (
        <span>
          {prevYear !== currentYear && <span style={{ fontSize: '14px', opacity: 0.7 }}>{prevYear}년 </span>}
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{prevMonth}월</span>
        </span>
      );
    }
  };

  const getNextText = () => {
    if (viewType === 'year') {
      return `${currentYear + 1}년`;
    } else if (viewType === 'week') {
      const nextQuarter = currentQuarter < 4 ? currentQuarter + 1 : 1;
      const nextYear = currentQuarter < 4 ? currentYear : currentYear + 1;
      return (
        <span>
          {nextYear !== currentYear && <span style={{ fontSize: '14px', opacity: 0.7 }}>{nextYear}년 </span>}
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{getQuarterMonthRange(nextQuarter)}</span>
        </span>
      );
    } else {
      const nextMonth = currentMonth < 12 ? currentMonth + 1 : 1;
      const nextYear = currentMonth < 12 ? currentYear : currentYear + 1;
      return (
        <span>
          {nextYear !== currentYear && <span style={{ fontSize: '14px', opacity: 0.7 }}>{nextYear}년 </span>}
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{nextMonth}월</span>
        </span>
      );
    }
  };

  
  return (
        <div id="cont-wrap">
            <div className={clsx('sv',{
                     'green' : ['develop','train'].includes(measureType)
                 })}>
                <div>
                    <h3>
                        {['develop','train'].includes(measureType) ? '두뇌 계발' : '뇌기능 검사'}
                    </h3>
                    <span>기본적인 항목을 검사 합니다.</span>
                    <i>Brain Health</i>
                </div>
            </div>

            <div className="cont">
                <Box mb={3}>
                    <Grid container className={'tabs sub-menu'}>
                      <Grid item xs={8}>
                        <MenuButtons measureType={measureType} onUpdate={(select) => handleTab(select)}/>
                      </Grid>
                      
                      <Grid item xs={4}>
                        <Box display={'flex'} justifyContent={'flex-end'} width={'100%'} style={{marginBottom: 20, paddingRight: 10}}>
                          <Button
                            className={classes.button}
                            endIcon={<ChevronRightIcon className={'rightIcon'}/>}
                            onClick={async () => {
                              setHistory(!showHistory)
                            }}
                          > 기록보기 </Button>
                        </Box>
                      </Grid>
                    </Grid>
                </Box>

                {!prescription &&
                    <FirstMeasureMessage />    
                }
                {prescription &&
                <>
                  { currentSelect === 0 &&
                    <Grid container spacing={3}>
                        {exercise.map((ex) => {
                            return (
                                <Grid item  md={4} xs={6} key={ex.id}>
                                    <ExerciseBox
                                        {...ex}
                                        history={props.history}
                                        prescriptionID={prescription.id}
                                        measureTypesCount={measureTypesCount.find(type => type.key === ex.programID)}
                                        onNeedTicket={() => {
                                            setOpen(true)
                                        }}
                                        measureType={measureType}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                  }
                  { currentSelect === 1 &&
                    <Box style={{border: '2px solid #ddd'}}>
                      <Grid container justify="center" alignItems="center" className={classes.viewTypeButtons}>
                        {['develop','train'].includes(measureType) && (
                          <Grid item style={{ marginRight: '20px' }}>
                            <FormControl variant="outlined" size="small">
                              <Select
                                value={selectedMode}
                                onChange={(e) => setSelectedMode(e.target.value)}
                                style={{
                                  backgroundColor: 'white',
                                  minWidth: 120,
                                  height: '40px'
                                }}
                              >
                                <MenuItem value="challenge">두뇌계발</MenuItem>
                                <MenuItem value="train">훈련</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item>
                          <Button 
                            className={viewType === 'year' ? 'active' : ''}
                            onClick={() => setViewType('year')}
                            style={{
                              backgroundColor: viewType === 'year' ? (['develop','train'].includes(measureType) ? '#257C40' : '#0054BF') : '#f5f5f5',
                              color: viewType === 'year' ? 'white' : '#666'
                            }}
                          >
                            년
                          </Button>
                          <Button 
                            className={viewType === 'week' ? 'active' : ''}
                            onClick={() => setViewType('week')}
                            style={{
                              backgroundColor: viewType === 'week' ? (['develop','train'].includes(measureType) ? '#257C40' : '#0054BF') : '#f5f5f5',
                              color: viewType === 'week' ? 'white' : '#666'
                            }}
                          >
                            주
                          </Button>
                          <Button 
                            className={viewType === 'day' ? 'active' : ''}
                            onClick={() => setViewType('day')}
                            style={{
                              backgroundColor: viewType === 'day' ? (['develop','train'].includes(measureType) ? '#257C40' : '#0054BF') : '#f5f5f5',
                              color: viewType === 'day' ? 'white' : '#666'
                            }}
                          >
                            일
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid container justify="center" className={classes.wrap} style={{
                        backgroundColor: ['develop','train'].includes(measureType) ? '#257C40' : '#0054BF'
                      }}>
                        <Grid item>
                          <Button
                            className={clsx('year', 'sideLeft')}
                            startIcon={<KeyboardArrowLeftIcon />}
                            onClick={handlePrevious}>
                            {getPreviousText()}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button className={'year'} style={{ 
                            fontSize: viewType === 'year' ? '32px' : 'inherit',
                            display: 'flex',
                            alignItems: 'baseline',
                            textTransform: 'none'
                          }}>
                            {getDateRangeText()}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button className={clsx('year', 'sideRight')}
                                  endIcon={<KeyboardArrowRightIcon />}
                                  onClick={handleNext}>
                            {getNextText()}
                          </Button>
                        </Grid>
                      </Grid>
                      
                      <div style={{
                        padding: '30px 20px',
                        position: 'relative'
                      }}>
                        {survey && survey.items && 
                          <Box style={{ 
                            overflowX: viewType !== 'year' ? 'auto' : 'visible',
                            overflowY: 'visible',
                          }}>
                            <Box style={{ 
                              minWidth: viewType !== 'year' ? '1200px' : 'auto',
                              width: viewType !== 'year' ? 'max-content' : '100%'
                            }}>
                              <MeasureTestHeatMap
                                items={survey.items}
                                startIndex={0}
                                currentYear={currentYear}
                                currentQuarter={currentQuarter}
                                currentMonth={currentMonth}
                                viewType={viewType}
                                useTerm={false}
                                recent={props.recent}
                                surveyType={props.surveyType}
                                measureType={measureType}
                              />
                            </Box>
                          </Box>
                        }
                      </div>
                    </Box>
                  }
                </>
                }
            </div>
            <NeedTicketDialog
                open={open} 
                onClose={(() => setOpen(false))}
            />
            <MeasureTestHistoryDialog
                exercise={exercise}
                measureType={measureType}
                open={showHistory}
                onClose={() => {
                    setHistory(false)
                }}
            />
        </div>
    )
}


export function MenuButtons(props){
  const { measureType } = props
  const buttons = [
    {
      title : ['develop','train'].includes(measureType) ? '두뇌 계발' : '뇌기능 검사',
    },
    {
      title : ['develop','train'].includes(measureType) ? '훈련 결과' : '검사 결과',
    },
  ]
  const [showType, setShowType] = useState(0)

  const isDevelop = ['develop','train'].includes(measureType)
  const customColor = isDevelop ? '#257C40' : '#0054BF'
  
  return (
    <Tabs
      value={showType}
      onChange={(event, newValue) => {
        setShowType(newValue)
        if (props.onUpdate) {
          props.onUpdate(newValue)
        }
      }}
      TabIndicatorProps={{
        style: {
          backgroundColor: customColor,
        }
      }}
      style={{ color: customColor }}
    >
      {buttons.map((button,index) => {
        return (
          <Tab key={index}
               className={'tab'}
               style={{
                 color: showType === index ? customColor : '#000'
               }}
               label={<SubMenuTabLabel
                 text={button.title}
                 style={{
                   fontWeight: 'bold',
                   color: showType === index ? customColor : '#000'
                 }}/>} />
        )
      })}
    </Tabs>
  )
}



export  function MeasureTestHeatMap(props) {
  const heatmapColor = ['develop','train'].includes(props.measureType) 
    ? ColorHelper.getSurveyTrainColors()
    : ColorHelper.getSurveyColors();
  
  const heatmapTextColor = ['develop','train'].includes(props.measureType)  
    ? ColorHelper.getSurveyTrainColor()
    : null
  
  const top5OrderIndex = []
  const classes = useStyles();
  const heatmapRef = React.useRef(null);

  if(props.recent && 0 < props.recent.items.length){
    let item
    for(let i = 0 ; i < 5; i++){
      item = props.recent.items[i]
      if(0 < item.level){
        top5OrderIndex.push(item.order)
      }
    }
  }
  
  let range = 12
  let startMonth = 1
  let xLabels = []
  
  if (props.viewType === 'week') {
    // 분기별 주차 표시
    const quarterMonths = {
      1: [1, 2, 3],
      2: [4, 5, 6],
      3: [7, 8, 9],
      4: [10, 11, 12]
    };
    
    const months = quarterMonths[props.currentQuarter];
    const weekLabels = [];
    
    // 각 월별로 주차 계산
    months.forEach(month => {
      const firstDay = new Date(props.currentYear, month - 1, 1);
      const lastDay = new Date(props.currentYear, month, 0);
      
      // 해당 월의 1일이 속한 주의 일요일 찾기
      let currentDate = new Date(firstDay);
      const firstDayOfWeek = firstDay.getDay(); // 0: 일요일, 6: 토요일
      currentDate.setDate(1 - firstDayOfWeek); // 해당 주의 일요일로 이동
      
      let weekOfMonth = 1;
      
      // 해당 월의 모든 주차 추가
      while (currentDate <= lastDay) {
        // 현재 주가 해당 월에 하루라도 포함되는지 확인
        const weekEndDate = new Date(currentDate);
        weekEndDate.setDate(weekEndDate.getDate() + 6); // 토요일
        
        // 주의 시작일 또는 종료일이 해당 월에 속하는 경우
        if ((currentDate.getMonth() === month - 1 && currentDate.getDate() <= lastDay.getDate()) ||
            (weekEndDate.getMonth() === month - 1)) {
          weekLabels.push({
            month: month,
            week: weekOfMonth,
            date: new Date(currentDate)
          });
          weekOfMonth++;
        }
        
        // 다음 주로 이동
        currentDate.setDate(currentDate.getDate() + 7);
      }
    });
    
    range = weekLabels.length;
    xLabels = weekLabels.map(item => {
      return (
        <div style={{ textAlign: 'center', lineHeight: 1.2 }}>
          <div style={{ fontSize: '14px', opacity: 0.7 }}>{item.month}월</div>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{item.week}주</div>
        </div>
      );
    });
  } else if (props.viewType === 'day') {
    // 월별 일자 표시
    const daysInMonth = new Date(props.currentYear, props.currentMonth, 0).getDate();
    range = daysInMonth;
    const today = new Date();
    const isCurrentMonth = today.getFullYear() === props.currentYear && (today.getMonth() + 1) === props.currentMonth;
    const todayDate = today.getDate();
    
    xLabels = new Array(range).fill(0).map((_, i) => {
      const day = i + 1;
      const isToday = isCurrentMonth && day === todayDate;
      return (
        <div style={{ 
          textAlign: 'center', 
          fontWeight: isToday ? 'bold' : 'normal',
          color: isToday ? '#FF843A' : 'inherit',
          backgroundColor: isToday ? '#fff2e6' : 'transparent',
          padding: '2px 4px',
          borderRadius: '4px'
        }}>
          {day}일
        </div>
      );
    });
  } else {
    // 년도별 월 표시 (기존 코드)
    if(props.useTerm){
      const term = 1 !== props.currentTerm ? props.currentTerm - 1 : 0
      startMonth = ( term * range) + 1
    }
    xLabels = new Array(range).fill(0).map((_, i) => `${i+startMonth}월`);
  }
  
  const xLabelsVisibility = new Array(range).fill(false)

  // 일 탭에서 오늘 날짜로 스크롤
  React.useEffect(() => {
    if (props.viewType === 'day' && heatmapRef.current) {
      const today = new Date();
      const isCurrentMonth = today.getFullYear() === props.currentYear && (today.getMonth() + 1) === props.currentMonth;
      if (isCurrentMonth) {
        const todayDate = today.getDate();
        const cellWidth = 70; // 셀 넓이
        const scrollPosition = (todayDate - 1) * cellWidth;
        
        setTimeout(() => {
          if (heatmapRef.current) {
            heatmapRef.current.scrollLeft = scrollPosition;
          }
        }, 100);
      }
    }
  }, [props.viewType, props.currentYear, props.currentMonth]);

  const yLabels = props.items.map((item, index) => {
      const title = `${index + 1 + props.startIndex}. ${item.content}`
      const isCheck = -1 < top5OrderIndex.indexOf(index + 1)
      return (
        <Box position={'relative'} className={'mapTitle'} style={{
          paddingRight: '0',
          position: 'absolute',
          left: 0,
          top: 1,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          height: '70px',
          width: '200px',
          borderBottom: '1px solid #ededed',
          background: 'white',
        }}>
          <Typography
            variant={'body1'}
            className={clsx(classes.wrapIcon,{
              [classes.check] : isCheck
            })}>
            {title}
            {isCheck && <StarIcon className={classes.check}/> }
          </Typography>

        </Box>
      )
    })

  const data = new Array(props.items.length).fill(0).map((_, rowIndex) =>
    new Array(xLabels.length).fill(0).map((_, columnIndex) => {
      const rounds = props.items[rowIndex].rounds
      if(rounds){
        let key;
        if (props.viewType === 'day') {
          // 일 단위: YYYY-MM-DD 형식
          const day = columnIndex + 1;
          key = `${props.currentYear}-${('00' + props.currentMonth).substr(-2)}-${('00' + day).substr(-2)}`;
        } else if (props.viewType === 'week') {
          // 주 단위: YYYY-MM-W## 형식 (백엔드와 동일)
          const quarterMonths = {
            1: [1, 2, 3],
            2: [4, 5, 6], 
            3: [7, 8, 9],
            4: [10, 11, 12]
          };
          
          const months = quarterMonths[props.currentQuarter];
          let weekIndex = 0;
          
          // columnIndex로 실제 월과 주차 찾기
          for (const month of months) {
            const firstDay = new Date(props.currentYear, month - 1, 1);
            const lastDay = new Date(props.currentYear, month, 0);
            let currentDate = new Date(firstDay);
            const firstDayOfWeek = firstDay.getDay();
            currentDate.setDate(1 - firstDayOfWeek);
            
            let weekOfMonth = 1;
            
            while (currentDate <= lastDay) {
              const weekEndDate = new Date(currentDate);
              weekEndDate.setDate(weekEndDate.getDate() + 6);
              
              if ((currentDate.getMonth() === month - 1 && currentDate.getDate() <= lastDay.getDate()) ||
                  (weekEndDate.getMonth() === month - 1)) {
                if (weekIndex === columnIndex) {
                  key = `${props.currentYear}-${('00' + month).substr(-2)}-W${('00' + weekOfMonth).substr(-2)}`;
                  break;
                }
                weekIndex++;
                weekOfMonth++;
              }
              
              currentDate.setDate(currentDate.getDate() + 7);
            }
            
            if (key) break;
          }
        } else {
          // 년 단위: YYYY-MM 형식
          key = props.currentYear + '-' + ('00' + (columnIndex + startMonth)).substr(-2)
        }
        
        const surveyAnswer = rounds[key]
        
        if(surveyAnswer && 0 < surveyAnswer.length){
          return {
            symptomLevel: surveyAnswer[0].symptomLevel,
            level: surveyAnswer[0].level,
            mode: surveyAnswer[0].mode
          }
        } else {
          return null
        }
      }

      return _
    })
  )

  yLabels.unshift('')
  data.unshift(xLabels)
  
  // 색상 범례 데이터 - heatmapColor 사용
  const colorLegend = [
    { color: heatmapColor[1], label: '10점' },
    { color: heatmapColor[2], label: '20점' },
    { color: heatmapColor[3], label: '30점' },
    { color: heatmapColor[4], label: '40점' },
    { color: heatmapColor[5], label: '50점' },
    { color: heatmapColor[6], label: '60점' },
    { color: heatmapColor[7], label: '70점' },
    { color: heatmapColor[8], label: '80점' },
    { color: heatmapColor[9], label: '90점' },
    { color: heatmapColor[10], label: '100점' }  // 인덱스 9 사용 (배열 길이가 10이므로)
  ];
  
  return (
    <div>
      {/* 색상 범례 */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        marginBottom: '20px',
        padding: '15px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          gap: '15px',
          alignItems: 'center'
        }}>
          <span style={{ 
            fontWeight: 'bold', 
            fontSize: '16px',
            marginRight: '10px',
            color: '#333'
          }}>
            점수 범례:
          </span>
          {colorLegend.map((item, index) => (
            <div key={index} style={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: '5px'
            }}>
              <div style={{
                width: '25px',
                height: '25px',
                backgroundColor: item.color,
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
              <span style={{ 
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#666'
              }}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      
      <HeatMap
        ref={heatmapRef}
        className={classes.map}
        xLabels={xLabels}
        yLabels={yLabels}
      xLabelsLocation={"bottom"}
      xLabelsVisibility={xLabelsVisibility}
      yLabelWidth={200}
      yLabelTextAlign={'left'}
      data={data}
      squares
      cellStyle={(background, value, min, max) => {
        
        let newBackground = `rgba(123, 201, 110, ${1 - (max - value) / (max - min)})`
        let color = '#333'
        
        const symptomLevel = value?.symptomLevel !== undefined ? value.symptomLevel : value;

        if(!symptomLevel && 0 !== symptomLevel) {
          newBackground = '#f3f3f3'
          color = `#ddd`
        } else { 
          newBackground = heatmapColor[(symptomLevel / 10)]
          if( 0 === symptomLevel ) {
            color = '#999'
            newBackground = '#efefef'
          } else if ( 60 < symptomLevel && !['develop','train'].includes(props.measureType)){
            newBackground = heatmapColor[(100 / 10)]
            color = '#fff'
          }
          
          if(heatmapTextColor && 0 < symptomLevel) {
            color = heatmapTextColor[symptomLevel / 10]
          }
        }
        const cellSize = '70px';
        return {
          background: newBackground,
          color,
          fontWeight: '900',
          fontSize: 20,
          width: cellSize,
          height: cellSize,
          lineHeight: cellSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }
      }}
      cellRender={ (value) => {
        let _value = value?.symptomLevel !== undefined ? value.symptomLevel : value;
        let level = value?.level;
        let mode = value?.mode;
        
        if('life' === props.surveyType && _value && !isNaN(_value)){
          _value = 100 - Number(_value) + 10
        }

        // level 표시 처리
        let displayLevel = level;
        if (level !== undefined && level !== null) {
          if (mode === 'train') {
            displayLevel = level === 1 ? '훈련' : level - 1;
          } else {
            displayLevel = level;
          }
        }

        return (
          <Box style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            lineHeight: 1.2
          }}>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{_value}</div>
            {level !== undefined && level !== null && (
              <div style={{ fontSize: '14px', opacity: 0.8 }}>
                Lv.{displayLevel}
              </div>
            )}
          </Box>
        )
      }}
      title={(value) => `${value}`}
    />
    </div>
  )
}


const useStyles = makeStyles(() => ({
    label: {
      fontSize:24,
      fontWeight: 'bold',
      colo: '#333'
    },
    wrapIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex'
    },
    check: {
      color: '#FF843A'
    },
    map: {
      '& .mapTitle': {
        // backgroundColor는 인라인 스타일로 처리
      }
    },
    viewTypeButtons: {
      padding: '10px',
      backgroundColor: '#f5f5f5',
      '& .MuiButton-root': {
        margin: '0 5px',
        padding: '8px 20px',
        borderRadius: '20px',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'all 0.3s ease'
      }
    },
    wrap: {
      '& .year': {
        fontSize: 32,
        fontWeight: 'bold',
        color: 'white'
      },
      '& .sideLeft': {
        color: '#CCCCCC',
        paddingRight: 60,
        '& .MuiSvgIcon-root': {
          fontSize: 30
        }
      },
      '& .sideRight': {
        color: '#CCCCCC',
        paddingLeft: 60,
        '& .MuiSvgIcon-root': {
          fontSize: 30
        }
      }
    },
    button: {
        border: '2px solid #BEBEBE',
        padding: '5px 30px',
        borderRadius: 20,
        color: '#666',
        '& .MuiButton-endIcon': {
            marginRight: -15
        },
        '& .rightIcon': {
            color: '#00DD94',
            fontSize: 25,
            fontWeight: 'bold'
        }
    },
}));


export default MeasureTestDefault
